import { useT, useAuthStore } from '@/store';
import { Navigation } from './Navigation';
import { SSEBadge } from './SSEBadge';
import { LanguageToggle } from './LanguageToggle';
import { NotificationBell } from './NotificationBell';
import { FleetKineticIcon } from '@/components/brand/FleetKineticMark';

/**
 * Sticky command bar: identity on the left, tabs in the middle, connection
 * state and language on the right. Stays mounted across view switches so
 * the SSE badge never flickers when a dispatcher changes tabs.
 */
export function Header() {
  const t = useT();
  const displayName = useAuthStore((s) => s.displayName);
  const signOut = useAuthStore((s) => s.signOut);

  return (
    <header className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-2 border-b border-line bg-bg/85 px-3 py-2.5 backdrop-blur-[10px] sm:gap-3 sm:px-[18px] sm:py-3">
      <div className="flex items-center gap-2.5">
        <FleetKineticIcon size={26} className="shrink-0" />
        <div className="font-brand text-[13.5px] font-bold leading-tight">
          FleetKinetic
          {/* The strapline is the first thing to go on a narrow screen: it
              explains nothing a dispatcher standing in a yard needs. */}
          <span className="hidden text-[9px] font-medium uppercase tracking-[0.08em] text-dim sm:block">
            {t('header.subtitle')}
          </span>
        </div>
      </div>

      {/* Nine tabs wrap to three rows at 390px and push the content below the
          fold. Scrolling them sideways keeps every view reachable while the
          BottomNav carries the four that matter on a phone. */}
      <div className="order-last w-full overflow-x-auto md:order-none md:w-auto md:overflow-visible">
        <Navigation />
      </div>

      <div className="flex items-center gap-2 sm:gap-2.5">
        <SSEBadge />
        <NotificationBell />
        <LanguageToggle />
        {/* The Driver App is a separate bundle, not a tab — see Navigation. */}
        <a className="btn hidden sm:inline-flex" href="/driver.html" title={t('nav.driverApp')}>
          🚛
        </a>
        {displayName ? (
          <button
            type="button"
            onClick={signOut}
            className="btn hidden max-w-[180px] truncate sm:inline-flex"
            title={displayName}
          >
            {displayName}
          </button>
        ) : null}
      </div>
    </header>
  );
}
